import { API } from 'api';

import { ReportUpdate } from 'features/reports/hooks/useReport/useReport.types';
import { Report } from 'features/reports/report.types';

export const fetchReport = async (reportId: number): Promise<Report> => {
  const resp = await API.get<Report>(`reports/${reportId}`);
  return resp.data;
};

export const deleteReport = async ({
  id,
  rejectDevice,
}: {
  id: number;
  rejectDevice?: boolean;
}): Promise<void> => {
  await API.delete(
    `reports/${id}${rejectDevice ? '?reject_ring_device=true' : ''}`,
  );
};

export const updateReport = async ({
  id,
  ...params
}: ReportUpdate): Promise<Report> => {
  const resp = await API.patch(`reports/${id}`, params);

  return resp.data as Report;
};
